import React from 'react';
import { useTranslation } from 'react-i18next';
import WelcomeHeader from '../components/layout/WelcomeHeader';
import styles from './InfoPage.module.css';

// TODO (Betreiber): Alle [...]-Platzhalter unten durch echte Angaben ersetzen,
// bevor die Seite öffentlich live geht. Pflichtangaben nach § 5 DDG (vormals
// § 5 TMG) für geschäftsmäßige Online-Angebote:
// - Name/Firma + ladungsfähige Anschrift (kein reines Postfach)
// - Vertretungsberechtigte Person (falls juristische Person)
// - Kontakt inkl. schneller elektronischer Erreichbarkeit
// - ggf. Registereintrag (Handelsregister/Vereinsregister) + USt-IdNr.
// - Verantwortliche(r) für den Inhalt nach § 18 Abs. 2 MStV (Name + Anschrift)
function Impressum({ loggedIn, username }) {
  const { t } = useTranslation();
  return (
    <>
      <WelcomeHeader loggedIn={loggedIn} username={username} />
      <div className={styles.pageContainer}>
        <div className={styles.contentWrapper}>
          <h1 className={styles.pageTitle}>{t('impressum.title')}</h1>
          <div className={styles.content}>
            <div className={styles.noticeBox}>
              ⚠️ {t('impressum.notice')}
            </div>

            <h2>{t('impressum.section5DdgTitle')}</h2>
            <p>
              {t('impressum.placeholderName')}<br />
              {t('impressum.placeholderStreet')}<br />
              {t('impressum.placeholderCity')}<br />
              {t('impressum.placeholderCountry')}
            </p>

            <h2>{t('impressum.contactTitle')}</h2>
            <p>
              {t('impressum.email')}: info@mangashelf.app<br />
              {t('impressum.website')}: https://mangashelf.app
            </p>

            <h2>{t('impressum.responsibleTitle')}</h2>
            <p>
              {t('impressum.placeholderResponsibleName')}<br />
              {t('impressum.placeholderStreet')}<br />
              {t('impressum.placeholderCity')}
            </p>

            <h2>{t('impressum.disclaimerTitle')}</h2>
            <h3>{t('impressum.contentLiabilityTitle')}</h3>
            <p>
              {t('impressum.contentLiabilityText')}
            </p>

            <h3>{t('impressum.linksLiabilityTitle')}</h3>
            <p>
              {t('impressum.linksLiabilityText')}
            </p>

            <h2>{t('impressum.copyrightTitle')}</h2>
            <p>
              {t('impressum.copyrightText')}
            </p>
          </div>
        </div>
      </div>
    </>
  );
}

export default Impressum;
